// @flow
const buildNamespace = process.env.NODE_NAMESPACE;
let buildHost = process.env.NODE_HOST;
if (window.location.host.includes("public")) {
  buildHost = window.location.origin;
}
const configKubernetes = {
  name: "configKubernetes",
  baseName: `/${buildNamespace}/ticketing-ui`,
  oldDomainUrl: `${buildHost}/${buildNamespace}/ops/#/`,
  zoomApiUrl: `${buildHost}/${buildNamespace}/backend`,
  loginUrl:
    "https://login.stg.rivigo.com/sso/login?client_id=ticketing-develop-client",
  logoutUrl: "https://login.stg.rivigo.com",
  ticketingApiUrl: `${buildHost}/${buildNamespace}/ticketing`,
  analyticsFlag: true,
  analyticsId: "UA-109460587-2",
  primeOpcApiUrl: "https://opc-api.stg.rivigo.com"
};

export default configKubernetes;



// WEBPACK FOOTER //
// ./app/configs/configKubernetes.js